import ChantierDetailController from './chantier.detail.controller';

export default {
    template: require('./chantier.detail.html'),
    controller: ChantierDetailController
};
